import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAssetsMetadataQueryVariables = Types.Exact<{
  assetIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type GetAssetsMetadataQuery = { __typename?: 'Query', assetsMetadata: Array<{ __typename?: 'AssetMetadata', mime?: string | null, size?: number | null, imageHeight?: number | null, imageWidth?: number | null, duration?: string | null }> };

export const GetAssetsMetadataDocument = gql`
    query GetAssetsMetadata($assetIds: [ID!]!) {
  assetsMetadata(assetIds: $assetIds) {
    mime
    size
    imageHeight
    imageWidth
    duration
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetsMetadataGQL extends Apollo.Query<GetAssetsMetadataQuery, GetAssetsMetadataQueryVariables> {
    document = GetAssetsMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }